export const normalizeDistrictKey = (uf?: string, cidade?: string, bairro?: string) =>
	`${uf?.toUpperCase()}|${cidade?.toUpperCase()}|${bairro?.toUpperCase()}`;
